import { useCallback } from 'react'
import { useFilteredTasks } from './useFilteredTasks'
import type { TaskDocument } from '@/lib/db/rxdb/schemas/task'

/**
 * Hook that returns inbox tasks (all top-level tasks with open status)
 */
export function useInboxTasks(options?: { includeSubTasks?: boolean }) {
  // Display → Show sub-tasks flattens them into the list (design 28b).
  const includeSubTasks = options?.includeSubTasks ?? false
  const predicate = useCallback(
    (task: TaskDocument, openStatusIds: ReadonlyArray<string>) =>
      openStatusIds.includes(task.statusId) &&
      (includeSubTasks || !task.parentId) &&
      !task.isArchived,
    [includeSubTasks],
  )

  return useFilteredTasks({ predicate, assignedToMeOnly: true })
}
